import SalesService from '../../service/SalesService'

const salesService = new SalesService();
var postedRecords = 0;

export const postSalesForecast = ({ dispatch, commit }, { that, rows, j, errMsg } ) => {
  try {
    var year = rows[0][0]
    
    let obj = {
      sYear: year,
      branch: rows[j][0],
      custCode: rows[j][1],
      forecasts: [],
      errMsg: ''
    }

    if (errMsg) {
      obj.errMsg = errMsg
    }

    for (let k = 3; k < rows[j].length; k++) {
      if (rows[1][k] && rows[j][k]) {
        obj.forecasts.push({
          sMonth: rows[1][k],
          forecastValue: rows[j][k]
        })
      }

      postedRecords = 0
      dispatch('setPostedRecords')

      if (k === rows[j].length - 1) {
        that.salesService
          .addForecastByYear(obj)
          .then(data => {
            // 

            postedRecords++
            dispatch('setPostedRecords')

            if ((j === rows.length - 1) && (k === rows[j].length - 1)) {
              setTimeout(() => {
                commit('SALES_FORECAST_POSTING', false)
              }, 7000)
            }
          })
          .catch(err => {
            dispatch('addSalesForecastErrors', `Error while saving for month ${rows[j][0]} and ${rows[j][1]}.`)

            if ((j === rows.length - 1) && (k === rows[j].length - 1)) {
              commit('SALES_FORECAST_POSTING', false)
            }

            // that.$toast.add({
            //   severity: "error",
            //   summary: "Error adding a row",
            //   detail: `Error while saving for month ${rows[j][0]} and ${rows[j][1]}.`,
            //   life: 5000,
            // })
          })
      }
    }

  } catch(e) {
    
  }
}

export const searchForCustomers = ({ dispatch, commit }, { that, rows } ) => {
  try {

    for(let j = 2; j < rows.length; j++) {
      // 

      salesService
        .getCustomerIdForBranch(rows[j][1], rows[j][0])
        .then(data => {
          
          dispatch('postSalesForecast', { that, rows, j, errMsg: '' })

        })
        .catch(error => {
          

          if (error) {
            var errMsg = ''
            if (error.response) {
              try {
                let word = "Customer", 
                  regex = new RegExp('\\b' + word + '\\b'), 
                  b = error.response.data.search(regex);
    
                errMsg = error.response.data.substring(b, error.response.data.length)
              } catch(e) {
                
                errMsg = error.response.data
              }
            }
            
            dispatch('postSalesForecast', { that, rows, j, errMsg })
          }

        })

    }
  } catch(e) {
    
  }
}

export const deleteSales = ({ dispatch, commit }, { that, rows } ) => {
  commit('SALES_FORECAST_ERRORS', [])
  commit('SALES_FORECAST_TOTALS', rows.length - 2)
  commit('SALES_FORECAST_POSTED', 0)

  try {
    commit('SALES_FORECAST_POSTING', true)
    
    var thisRows = []
    if (typeof rows[1][rows[1].length - 1] === 'string') {
      rows.forEach(row => thisRows.push(row.slice(0, row.length - 1)))
    } else {
      thisRows = [...rows]
    }

    var year = thisRows[0][0] 
    if (year && thisRows[1] && thisRows[1].length <= 15) { // if this is the format of the file
      
      dispatch('searchForCustomers', { that, rows: thisRows })

      // for(let i = 3; i < thisRows[1].length; i++) {
      //   

      //   salesService
      //     .deleteSales(year, thisRows[1][i])
      //     .then(data => {
  
      //       if (i === thisRows[1].length - 1) {
      //         dispatch('searchForCustomers', { that, rows: thisRows })
      //       }
  
      //     })
      //     .catch(error => {
  
      //       if (i === thisRows[1].length - 1) {
      //         dispatch('searchForCustomers', { that, rows: thisRows })
      //       }
  
      //       

      //       dispatch('addSalesForecastErrors', `Error while deleting for month ${rows[1][i]}.`)
            
      //       that.$toast.add({
      //         severity: "error",
      //         summary: "Error",
      //         detail: `Error while deleting for month ${thisRows[1][i]}.`,
      //         life: 5000,
      //       })
      //     })
      // }
    } else {
      commit('SALES_FORECAST_POSTING', false)
    }

  } catch(e) {
    
  }
  
}

export const addSalesForecastErrors = ({ commit, getters }, str) => {
  if (str) {
    let a = getters['getSalesForecastErrors']
    if (Array.isArray(a)) {
      let b = [...a, {
        severity: 'error',
        content: str
      }]
      commit('SALES_FORECAST_ERRORS', b)
    } else {
      commit('SALES_FORECAST_ERRORS', [{
        severity: 'error',
        content: str
      }])
    }
  } else {
    commit('SALES_FORECAST_ERRORS', [])
  }
}

export const setPostedRecords = ({ commit }) => {
  commit('SALES_FORECAST_POSTED', postedRecords)
}

export const addSalesForecastPosted = ({ commit, getters }) => {
  let a = getters.getSalesForecastPosted
  commit('SALES_FORECAST_POSTED', a+=1)
}


export const setMainListQuickFilters = ({ commit }, obj ) => {
  commit('MAIN_LIST_QUICK_FILTER', obj)
}

export const setQuickFiltersDatesFrom = ({ commit }, obj ) => {
  commit('QUICK_FILTERS_DATES_FROM', obj)
}

export const setQuickFiltersDatesTo = ({ commit }, obj ) => {
  commit('QUICK_FILTERS_DATES_TO', obj)
}